import React from 'react';
import MypageQnAPresenter from './MypageQnAPresenter';
import { useDefaultShopDataStack, useUserDataStack, useUserStack } from 'store';
import { STORE_URL } from 'utils';

const MypageQnAContainer = (props) => {
  /* ===== ROUTE ===== */
  /* ===== Props ===== */
  const { screenSize } = props;

  /* ===== Store ===== */
  const userInfo = useUserStack();
  const { shops } = useDefaultShopDataStack();
  const { inquiryList } = useUserDataStack();

  /* ===== STATE ===== */
  // 로딩
  const [isLoading, setIsLoading] = React.useState(false);

  /* ===== HOOKS ===== */
  /**
   * 상품 문의 목록 정제
   * --
   */
  const InquiryList = React.useMemo(() => {
    if (!inquiryList.length) return [];

    const filterData = inquiryList.filter(
      (inquiry) =>
        inquiry.inquiry_type === 'PRODUCT' ||
        inquiry.inquiry_type === 'DELIVERY'
    );

    const newInquiryList = filterData.map((inquiry) => {
      const {
        inquiry_name,
        inquiry_content,
        inquiry_answer,
        created_at,
        updated_at,
        shop_information_id,
        is_secret,
        inquiry_file,
      } = inquiry;

      // NOTE: 답변 업체
      const shop = shops?.find(
        (sh) => sh.shop_information_id === shop_information_id
      );

      // NOTE: 파일 정제
      const files = inquiry_file.length
        ? inquiry_file.map((file) => ({
            ...file,
            file_url: `${STORE_URL}/${file.file_url}`,
          }))
        : null;

      return {
        title: inquiry_name,
        content: inquiry_content,
        answer: inquiry_answer,
        answerName: shop?.shop_information_name,
        create: created_at,
        status: inquiry_answer ? 'DONE' : 'WAIT',
        update: updated_at,
        secret: is_secret,
        files: files,
      };
    });

    const sortData = newInquiryList.sort((a, b) => b.create - a.create);

    return sortData;
  }, [inquiryList, shops]);

  /* ===== RENDER ===== */
  return (
    <>
      <MypageQnAPresenter
        user={userInfo}
        inquiries={InquiryList}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        screenSize={screenSize}
      />
    </>
  );
};

export default MypageQnAContainer;
